import { memo } from 'react';

import { useErrorTranslations } from '@/hooks';

import { Error } from './Error';

export const NotFoundPage = memo(function NotFoundPage() {
  const errorTranslations = useErrorTranslations();

  return (
    <Error
      statusCode={404}
      title={errorTranslations['404'].title}
      description={errorTranslations['404'].message}
    />
  );
});
